import { DARStore } from "@/types/store";
import { Store } from "vuex";
import { createConnection } from "@/store/plugins/websocket/createConnection";
import { sendOutgoingMessages } from "@/store/plugins/websocket/sendOutgoingMessages";

export default function createWebSocketPlugin() {
  return (store: Store<DARStore>) => {
    store.subscribeAction((action, state) => {
      sendOutgoingMessages(action, store);
    });

    createConnection(store);
  };
}
